/* Mobile menu drawer.
   The open/closed state is expressed only through aria-hidden on #sm-drawer;
   the visual state is driven from the stylesheet in sections/header.liquid.
   Keep opacity and pointer-events OUT of the drawer's inline style attribute,
   or the stylesheet can never win and the drawer stays invisible. */
(function () {
  function drawer() { return document.getElementById('sm-drawer'); }
  function burger() { return document.querySelector('[data-sm-menu-open]'); }

  function setOpen(isOpen) {
    var d = drawer();
    if (!d) return;
    d.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.style.overflow = isOpen ? 'hidden' : '';
    var b = burger();
    if (b) {
      b.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      b.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    }
    if (isOpen) {
      var close = d.querySelector('[data-sm-menu-close]');
      if (close) close.focus();
    } else if (b) {
      b.focus();
    }
  }

  document.addEventListener('click', function (e) {
    if (!drawer()) return;
    if (e.target.closest('[data-sm-menu-open]')) { setOpen(true); return; }
    if (e.target.closest('[data-sm-menu-close]')) { setOpen(false); return; }
    if (e.target === drawer()) { setOpen(false); return; }
    /* tapping a link inside the drawer should close it before navigating */
    var link = e.target.closest('#sm-drawer a');
    if (link) setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = drawer();
    if (d && d.getAttribute('aria-hidden') === 'false') setOpen(false);
  });

  /* if the viewport grows past the breakpoint the burger disappears, so make
     sure a drawer left open does not keep the page scroll locked */
  window.addEventListener('resize', function () {
    var d = drawer();
    if (window.innerWidth > 900 && d && d.getAttribute('aria-hidden') === 'false') setOpen(false);
  });
})();
